import axios from 'axios';
import { AuthContextValue } from '@/contexts/auth';
import { API_PREFIX } from '@/constants';
// import { CustomerStatus } from './detail';
import { TaskStatus, Summary } from '.';


export type TaskType = 'AI_AND_SMS_AND_ASSIGN' | 'AI_AND_ASSIGN' | 'SMS_AND_ASSIGN' | 'ASSIGN';

export type TaskSummaryResult = {
  taskNum: number;
  customerNum: number;
  taskStatus: TaskStatus;
}[];

export interface TaskListQueryParams extends Pagination {
  status: TaskStatus;
  auth: AuthContextValue;
}

export type TaskListResult = {
  data: {
    planId: number;
    taskId: number;
    taskName: string;
    time: string;
    waitAddNum: number;
    waitPassNum: number;
    finishNum: number;
    addFriendType: TaskType;
  }[] | null;
  total: number;
  page: number;
  pageSize: number;
};

export type GlobalConfigResult = {
  filter: boolean;
  times: number;
}

export const queryTaskSummary = async (auth: AuthContextValue) => {
  const { corpId, userId } = auth;
  const res = await axios.get<TaskSummaryResult>(`${API_PREFIX.CUSTOMER}/user/task/list`, {
    params: { userId, corpId }
  });
  if (res && res.data) {
    return res.data.reduce(
      (pre, { taskStatus: s, taskNum: tasksCount, customerNum: customersCount }) => ({
        ...pre,
        [s]: {
          tasksCount,
          customersCount
        }
      })
      , ({} as Summary));
  }
}

export const queryTaskList = async ({ status, current, pageSize, auth }: TaskListQueryParams) => {
  const { corpId, userId } = auth;
  const res = await axios.get<TaskListResult>(`${API_PREFIX.CUSTOMER}/user/task/pageList`, {
    params: { taskStatus: status, page: current, pageSize, userId, corpId }
  });
  if (res && res.data) {
    const { data = [], page, pageSize, total } = res.data;
    return {
      data,
      current: page,
      pageSize,
      total
    };
    // const currentList = res.data.find(({ taskStatus: s }) => status === s);
    // const statusAnalysis: Record<TaskStatus, number> = res.data.reduce(
    //   (pre, { taskStatus: s, taskNum: n }) => ({ ...pre, [s]: n })
    //   , ({} as Record<TaskStatus, number>));
    // const { taskList, taskNum, customerNum } = currentList;
    // return {
    //   data: taskList?.map(({ waitAddNum, waitPassNum, finishNum, ...r }) => ({
    //     ...r,
    //     status: {
    //       [CustomerStatus.toadd]: waitAddNum,
    //       [CustomerStatus.expecting]: waitPassNum,
    //       [CustomerStatus.finished]: finishNum
    //     }
    //   })) || [],
    //   pagination: {
    //     current: 1,
    //     pageSize: taskList?.length || 0,
    //     total: taskList?.length || 0
    //   },
    //   analysis: {
    //     tasks: taskNum,
    //     customers: customerNum,
    //     status: statusAnalysis
    //   }
    // };
  }
}

export const queryGlobalConfig = async (auth: AuthContextValue) => {
  const { corpId } = auth;
  const res = await axios.get<GlobalConfigResult>(`${API_PREFIX.CUSTOMER}/user/task/${corpId}/phone/config`);
  if (res && res.data) {
    return res.data;
  }
}
